import { toast, ToastContainer } from "react-toastify";
import { useForm, SubmitHandler } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";

import { AppDispatch, RootState } from "../../../core/data/redux/store";
import { updatePassword, resetAuth } from "../../../core/data/redux/action";


const ChangePassword = () => {
  const [isToggle, setIsToggle] = useState(false);
  const [isToggle1, setIsToggle1] = useState(false);
  const [isToggle2, setIsToggle2] = useState(false);

  type FormValues = {
    current_password: string;
    password: string;
    password_confirmation: string;
  };

  const dispatch = useDispatch<AppDispatch>();

  const { user, success, error } = useSelector((state: RootState) => ({
    success: state.auth.success,
    user: state.auth.user,
    error: state.auth.error,
  }));

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitted },
    reset,
  } = useForm<FormValues>({
    defaultValues: {
      current_password: "",
      password: "",
      password_confirmation: "",
    },
  });

  const onSubmit: SubmitHandler<FormValues> = (data) => {
    dispatch(updatePassword(data));
  };

  useEffect(() => {
    if (success) {
      if (success !== "User profile retrieved successfully") {
        showToast(success);
      }

      reset();
      dispatch(resetAuth());

      const backdrop = document.querySelector(".modal-backdrop");
      const changePasswordModal = document.getElementById("change_password");

      if (changePasswordModal) {
        changePasswordModal.style.display = "none";
        changePasswordModal.classList.remove("show", "modal-open");
      }

      if (backdrop) {
        backdrop.remove();
      }

      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } else if (error) {
      reset();
      dispatch(resetAuth());
      showToast(error);
    }
  }, [user, success, error]);

  const [toastMessage, setToastMessage] = useState("");
  const [toastClass, setToastClass] = useState("bg-success text-white");

  const showToast = (message: any) => {
    setToastClass(error ? "bg-danger text-white" : "bg-success text-white");
    setToastMessage(message);
  };

  const handleCloseToast = () => {
    setToastMessage("");
  };

  useEffect(() => {
    if (toastMessage) {
      if (toastClass === "bg-danger text-white") {
        toast.error(toastMessage, {
          position: "top-right",
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: "",
        });
      } else {
        toast.success(toastMessage, {
          position: "top-right",
          hideProgressBar: true,
          onClose: handleCloseToast,
          progress: undefined,
          toastId: "",
        });
      }
    }
  }, [toastMessage, toastClass]);

  return (
    <div>
 {toastMessage &&  <ToastContainer autoClose={3000} />}
 
      <div
        className="modal new-modal fade"
        id="change_password"
        data-keyboard="false"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Change Password</h4>
              <button
                type="button"
                className="close-btn"
                data-bs-dismiss="modal"
              >
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="modal-form-group">
                      <label>
                        Current Password <span className="text-danger">*</span>
                      </label>

                      <div className="pass-group">
                        <input
                          type={isToggle ? "text" : "password"}
                          className={`form-control pass-input-three ${isSubmitted && errors?.current_password ? "is-invalid" : ""}`}
                          placeholder="..........."
                          {...register("current_password", {
                            required: "Password is required",
                          })}
                        />
                        <span
                          onClick={() => setIsToggle(!isToggle)}
                          className={`fas toggle-password ${
                            isToggle ? "fa-eye" : "fa-eye-slash"
                          }`}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="modal-form-group">
                      <label>
                        New Password <span className="text-danger">*</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={isToggle1 ? "text" : "password"}
                          className={`form-control pass-input-three ${isSubmitted && errors?.password ? "is-invalid" : ""}`}
                          placeholder="..........."
                          {...register("password", {
                            required: "Password is required",
                          })}
                        />
                        <span
                          onClick={() => setIsToggle1(!isToggle1)}
                          className={`fas toggle-password ${isToggle1 ? "fa-eye" : "fa-eye-slash"}`}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="modal-form-group">
                      <label>
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <div className="pass-group">
                        <input
                          type={isToggle2 ? "text" : "password"}
                          className={`form-control pass-input-three ${isSubmitted && errors?.password_confirmation ? "is-invalid" : ""}`}
                          placeholder="..........."
                          {...register("password_confirmation", {
                            required: "Password is required",
                          })}
                        />
                        <span
                          onClick={() => setIsToggle2(!isToggle2)}
                          className={`fas toggle-password ${isToggle2 ? "fa-eye" : "fa-eye-slash"}`}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-btn modal-btn-sm">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 btn-size"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Change Password Modal */}
    </div>
  );
};

export default ChangePassword;
